import React, { useMemo } from 'react';
import Section from '../../../Components/Containers/Section';
import Chart, { pickColour } from '../../../Components/Chart';
import ErrorBoundary from '../../../Components/Containers/ErrorBoundary/ErrorBoundary';
import { formatTooltipLabel, tickCallback, getDateLabel } from './helpers';
import NoData from './NoData';

/*
[
    {
        "dataLabel": "Malcolm Christie",
        "data": [
            {
                "label": "2023-01",
                "value": 0
            },
            {
                "label": "2023-02",
                "value": 0
            },
            ...
        ]
    },
    {
        "dataLabel": "Testie Fourty",
        "data": [
            {
                "label": "2023-01",
                "value": 0
            },
            {
                "label": "2023-02",
                "value": 0
            },
            ...
        ]
    },
    ...
]
*/
const MultiTimeSeriesChart = ({title, subtitle, dataType, data, hideEmptyDatasets}) => {

    const marshalledData = useMemo(() => {
        const filtered = hideEmptyDatasets ? data.filter(series => series.data.some(d => d.value !== 0)) : data;
        return {
            labels: filtered[0].data.map(d => getDateLabel(d.label)),
            datasets: filtered.map((series, i) => ({
                label: series.dataLabel,
                data: series.data.map(d => d.value),
                backgroundColor: pickColour(i, filtered.length),
            }))
        };
    }, [data, hideEmptyDatasets]);

    if (data.length === 0 || data.every(series => series.data.every(d => d.value === 0))) {
        return <NoData title={title} subtitle={subtitle} />
    }

    return <Section title={title} subtitle={subtitle}>
        <ErrorBoundary>
            <Chart type="Bar"
                size="max-h-[75vh] w-auto"
                data={marshalledData}
                options={getOptions(dataType)}
            />
        </ErrorBoundary>
    </Section>
}

const getOptions = (dataType) => {
    return {
        indexAxis: 'x',
        plugins: {
            tooltip: {
                callbacks: {
                    title: (context) => context[0].label.replaceAll(',', ' '),
                    label: (tooltipItem, data) => formatTooltipLabel(tooltipItem, data, dataType),
                }
            },
            legend: {
                display: true,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                stepSize: 1,
                precision: 0,
                ticks: {
                    callback: (value, index, values) => tickCallback(value, index, values, dataType),
                }
            },
        },
    };
}

export default MultiTimeSeriesChart;
